import * as React from 'react';
import { Subscribe } from 'unstated';

import StateContainer from '../StateContainer';
import ProductSelect from '../../../../components/Others/ProductSelect';
import GetFullVariants from '../../../../components/Query/Products/GetFullVariants';
import ProductLine from './ProductLine';

export interface IRecommendedProductsTabProps {
    container: StateContainer;
  }

export class RecommendedProductsTab extends React.PureComponent<IRecommendedProductsTabProps> {
    render() {
        const { container } = this.props;

        return (
            <Subscribe to={[container]}>
                {productDetail => {
                    const recommendedProductVariantIds = Array.isArray(productDetail.state.product.recommendedProductVariantIds)
                    ? productDetail.state.product.recommendedProductVariantIds
                    : Array.isArray(productDetail.state.product.recommendedProductVariants)
                        ? productDetail.state.product.recommendedProductVariants
                            .sort((a, b) => a.order - b.order)
                            .map(v => v.productVariant && v.productVariant.id || undefined)
                        : [];
                    return (
                        <>
                            <GetFullVariants ids={recommendedProductVariantIds}>
                                {(variantsData) => {
                                    if (undefined === variantsData.fullVariants.variants) {
                                        variantsData.fullVariants.refetch();
                                    }
                                    if (!variantsData.fullVariants || variantsData.fullVariants.loading || !Array.isArray(variantsData.fullVariants.variants)) {
                                        return 'Loading ...'
                                    }

                                    const variants = recommendedProductVariantIds.map((vId: string) => variantsData.fullVariants.variants.find(v => v.id === vId));

                                    return variants.map((variant: GQL.IProductVariant, index: number) => (
                                        <ProductLine
                                            key={variant.id}
                                            variant={variant}
                                            moveUp={() => this.moveProduct(variant.id, recommendedProductVariantIds, container, 'up')}
                                            moveDown={() => this.moveProduct(variant.id, recommendedProductVariantIds, container, 'down')}
                                            onDelete={() => {
                                                container.onChange('recommendedProductVariantIds', recommendedProductVariantIds.filter(id => id !== variant.id));
                                            }}
                                            language={productDetail.state.currentLanguage}
                                            disabledUp={index === 0}
                                            disabledDown={index===variants.length - 1}
                                        />
                                    ))
                                }}
                            </GetFullVariants>
                            <ProductSelect
                                name="recommendedProductVariantIds"
                                // value={recommendedProductVariantIds}
                                onChange={(e) => {
                                    const newId = e.target.value;
                                    if (recommendedProductVariantIds.indexOf(newId) > -1) {
                                        return;
                                    }
                                    recommendedProductVariantIds.push(newId);
                                    container.onChange(e.target.name, recommendedProductVariantIds);
                                }}
                                language={productDetail.state.currentLanguage}
                            />
                        </>
                    )
                }}
            </Subscribe>
        );
    }

    private moveProduct(id: string, ids: string[], container: StateContainer, direction: 'up' | 'down') {
        const currentIndex = ids.indexOf(id);
        if (currentIndex < 0) {
            return;
        }

        if (currentIndex === 0 && direction === 'up') {
            return;
        }

        if (currentIndex === (ids.length - 1) && direction === 'down') {
            return;
        }

        const newIds = ids.filter(existing => existing !== id);

        newIds.splice(currentIndex + (direction === 'down' ? 1 : -1), 0, id);

        container.onChange('recommendedProductVariantIds', newIds);
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/RecommendedProductsTab/RecommendedProductsTab.tsx